import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { auth, firestore } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import FileHandler from './FileHandler';
import { handleCheckout } from './checkoutUtils'; // Ensure this supports a productType parameter if needed.
import './Navbar.css';
import ProfileOrLogin from './ProfileOrLogin';
import SubscriptionModal from './SubscriptionModal';
import ReactDOM from 'react-dom';
import { useUser } from '../contexts/UserContext';

const Navbar = () => {
  const [userId, setUserId] = useState(null);
  const [loadingUpgrade, setLoadingUpgrade] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const user = auth.currentUser;
  const { onSignupOpen } = useUser();


  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isExpanded) {
        setIsExpanded(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isExpanded]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        checkSubscriptionStatus(user.uid);
      } else {
        setUserId(null);
        setIsSubscribed(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const checkSubscriptionStatus = async (userId) => {
    if (!userId) return;
    const subscriptionRef = collection(firestore, "users", userId, "subscriptions");
    const q = query(subscriptionRef, where("status", "in", ["trialing", "active"]));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setIsSubscribed(snapshot.docs.length > 0);
    });
    return () => unsubscribe();
  };

  // Instead of immediately triggering checkout, we open the subscription modal.
  const handleUpgradeClick = () => {
    if (loadingUpgrade) return;
  
    // fire the conversion event
    if (window.gtag_report_conversion) {
      // passing no URL means we stay on-page
      window.gtag_report_conversion();
    }
  
    setLoadingUpgrade(true);
    setShowSubscriptionModal(true);
    setLoadingUpgrade(false);
  };

  // For navbar upgrades, success should redirect to home.
  const handleSubscriptionSuccess = () => {
    window.location.href = "/";
  };

  // Opens the signup modal – your signup modal logic should handle this.
  const handleRequireSignup = () => {
    onSignupOpen();
    setShowSubscriptionModal(false);
  };


  return (
    <nav className="navbar">
      <div className="navbar-row top-row">
        <Link to="/" className="brand">PositionPrep</Link>
      </div>
      <div className={`navbar-row navLinks bottom-row ${isExpanded ? "expanded" : ""}`}>
        <Link to="/resume-builder" className="nav-text-link">
          Resume Builder
        </Link>
        <Link to="/cover-letter" className="nav-text-link">
          Cover Letter
        </Link>
        <Link to="/interview-questions" className="nav-text-link">
          Interview Questions
        </Link>
        {!isSubscribed && (
          <button
            className="upgrade-button"
            onClick={handleUpgradeClick}
            disabled={loadingUpgrade}
          >
            {loadingUpgrade ? (
              <span>
                <div className="spinner"></div>
              </span>
            ) : (
              'Upgrade'
            )}
          </button>
        )}
        <div className="profile-link">
          <ProfileOrLogin user={user} />
        </div>
      </div>

      {/* Render Subscription Modal via Portal */}
      {showSubscriptionModal &&
        ReactDOM.createPortal(
          <div className="subscription-overlay">
            <div className="subscription-modal">
              <button
                className="modal-close"
                onClick={() => setShowSubscriptionModal(false)}
              >
                ×
              </button>
              <SubscriptionModal
                isOpen={true}
                onClose={() => setShowSubscriptionModal(false)}
                onSubscriptionSuccess={handleSubscriptionSuccess}
                onRequireSignup={handleRequireSignup}
                productType="navbar" // Pass the product type for navbar upgrades
              />
            </div>
          </div>,
          document.getElementById('modal-root')
        )
      }
    </nav>
  );
};

export default Navbar;
